module.exports = __webpack_public_path__ + "img/accounting.e3da925d.png";